<div class="absolute right-0 top-full z-50 mt-2 w-80 sm:w-96 origin-top-right rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg"
  (outsideClick)="closeModal.emit()" outside-click role="dialog" aria-label="Notifications">

  <!-- Header -->
  <div class="flex items-center justify-between gap-2 px-4 py-2 border-b border-zinc-950/10 dark:border-white/10">
    <h3 class="text-sm font-semibold text-main-dark">
      Notifications
      <span *ngIf="unreadCount > 0" class="ml-1 text-xs font-normal text-zinc-500">({{ unreadCount }} unread)</span>
    </h3>
    <button *ngIf="hasUnread" type="button" class="text-xs text-main-primary hover:underline" (click)="onMarkAllAsRead()">
      Mark all as read
    </button>
  </div>

  <!-- List -->
  <div class="max-h-96 overflow-y-auto">
    <div *ngIf="loading" class="px-4 py-6 text-center text-sm text-zinc-500 dark:text-zinc-400">Loading...</div>

    <div *ngIf="!loading && !notifications.length" class="px-4 py-6 text-center text-sm text-zinc-500 dark:text-zinc-400">
      No notifications today
    </div>

    <ul *ngIf="notifications.length" class="p-2 space-y-2">
      <li *ngFor="let notification of notifications; trackBy: trackById">
        <button type="button" (click)="onNotificationClick(notification)"
          class="flex w-full items-start gap-3 rounded-lg border p-3 text-left transition-all duration-150 hover:shadow-sm"
          [ngClass]="notification.isRead
            ? 'border-zinc-200/80 bg-zinc-50/50 hover:bg-zinc-100/70 dark:border-zinc-800/80 dark:bg-zinc-900/40 dark:hover:bg-zinc-900/80'
            : 'border-l-4 border-l-zinc-400 border-zinc-300/80 bg-zinc-100/70 hover:bg-zinc-200/70 shadow-sm dark:border-l-zinc-500 dark:border-zinc-700/80 dark:bg-zinc-800/60 dark:hover:bg-zinc-800/90'">
          <div class="min-w-0 flex-1">
            <div class="flex items-start justify-between gap-2">
              <div class="flex min-w-0 items-center gap-2">
                <p class="truncate text-sm"
                  [ngClass]="notification.isRead ? 'font-medium text-zinc-600 dark:text-zinc-400' : 'font-semibold text-zinc-950 dark:text-white'">
                  {{ notification.title | titlecase }}
                </p>
                <span *ngIf="notification.company?.CompanyName" class="badge-secondary shrink-0">
                  {{ notification.company.CompanyName }}
                </span>
              </div>
              <span *ngIf="!notification.isRead"
                class="inline-flex shrink-0 items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-zinc-100 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-200">
                <span class="size-1.5 rounded-full bg-zinc-600 dark:bg-zinc-400"></span>
                New
              </span>
            </div>
            <p class="mt-1 text-xs line-clamp-2"
              [ngClass]="notification.isRead ? 'text-zinc-500 dark:text-zinc-400' : 'text-zinc-700 dark:text-zinc-200 font-medium'">
              {{ notification.message }}
            </p>
            <p class="mt-1.5 text-[11px] text-zinc-400 dark:text-zinc-500">
              {{ getRelativeTime(notification.createdAt) }}
            </p>
          </div>
        </button>
      </li>
    </ul>
  </div>

  <!-- Footer -->
  <div class="flex items-center justify-end gap-2 px-4 py-2 border-t border-zinc-950/10 dark:border-white/10">
    <button type="button" class="text-xs text-main-primary hover:underline" (click)="viewAll()">View all</button>
  </div>
</div>
